import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { TuiLink, TuiNotification } from '@taiga-ui/core';
import { Observable } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { StorageService } from 'src/app/services/storage.service';
import { StorageSpace } from 'src/app/shared/models/paywall/storage-space.enum';
import { DataConsumptionComponent } from '../data-consumption/data-consumption.component';

@Component({
  selector: 'pxc-paywall-alert',
  templateUrl: './paywall-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TuiNotification, TuiLink, TranslocoDirective],
})
export class PaywallAlertComponent implements OnInit {
  private readonly storageService = inject(StorageService);
  private readonly dialogService = inject(DialogService);
  private readonly translocoService = inject(TranslocoService);

  storageSpace$: Observable<StorageSpace>;
  showStorageWarningNotification = true;
  StorageSpace = StorageSpace;

  closed = false;

  ngOnInit(): void {
    this.storageSpace$ = this.storageService.getActiveClientStorageSpace();
  }

  manageStorage(): void {
    this.dialogService
      .openComponent(DataConsumptionComponent, {
        label: this.translocoService.translate('Gérer votre stockage'),
        data: { detailedMode: true },
      })
      .subscribe();
  }

  close(): void {
    this.closed = true;
  }
}
